/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum CloudServiceName {
    AWS = 'AWS',
    Azure = 'Azure',
    AzureStack = 'AzureStack',
    Azure_CSP = 'Azure_CSP',
    Azure_CSP_Direct = 'Azure_CSP-Direct',
    Azure_EA = 'Azure_EA',
    Azure_MCA = 'Azure_MCA',
    Cloudstack = 'Cloudstack',
    GCP = 'GCP',
    MS_VMM = 'MS_VMM',
    OCI = 'OCI',
    Openstack = 'Openstack',
    PrivateCloud = 'PrivateCloud',
    Rackspace = 'Rackspace',
    VMware = 'VMware',
    VMware_VCD = 'VMware_VCD',
    vCenter = 'vCenter'
}
